import { useQuery } from 'react-query';
import { usePublicApiClient } from '../usePublicApiClient';
import { ContentfulThemeApiClient } from '@jbhi-fi/apis/src/contentfulThemeApi';
import { ContentfulSearchContent } from '@jbhi-fi/apis/src/contentful/types';
import { ContentfulClient } from '@jbhi-fi/apis/src/contentful/ContentfulClient';

export type UseContentfulSearchContentResult = {
  isLoading?: boolean;
  searchContentResults?: Array<ContentfulSearchContent>;
};

export const useContentfulSearchContent = ({
  contentfulThemeApiClient: contentfulThemeApiClientProp,
  contentfulClient: contentfulClientProp,
  searchTerm,
}: {
  contentfulThemeApiClient?: ContentfulThemeApiClient;
  contentfulClient?: ContentfulClient;
  searchTerm: { term: string };
}): UseContentfulSearchContentResult => {
  const { contentfulThemeApiClient: contentfulThemeApiClientContext, contentfulClient: contentfulClientContext } =
    usePublicApiClient();
  const contentfulThemeApiClient = contentfulThemeApiClientProp || contentfulThemeApiClientContext;
  const contentfulClient = contentfulClientProp || contentfulClientContext;
  if (!contentfulThemeApiClient) {
    throw new Error(
      'useContentfulSearchContent must be provided with a contentfulThemeApiClient via PublicApiClientProvider or props'
    );
  }
  const isPreview = window.Jbhifi?.isContentPreview || false;
  const keywords = searchTerm?.term;

  const contenfulClientQueryOptions = {
    content_type: 'searchContent',
    include: '6',
    order: 'fields.order',
    'fields.keywords[match]': keywords,
  };

  const { data, isLoading } = useQuery({
    enabled: !!contentfulThemeApiClient || !!contentfulClient,
    queryKey: ['useContentfulSearchContent', keywords],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryFn: async () =>
      isPreview
        ? await contentfulThemeApiClient?.getEntries<ContentfulSearchContent>({
            ...contenfulClientQueryOptions,
            cache: 'medium',
          })
        : await contentfulClient?.getResolvedEntries(contenfulClientQueryOptions),
  });

  const results = data?.data?.items || [];
  return {
    isLoading,
    searchContentResults: results,
  };
};
